// extracted by mini-css-extract-plugin
export default {"skillsets":"Skills_skillsets__KOffn","skillset-container":"Skills_skillset-container__K2+lw"};